import createIcon from '../../createIcon';

/**
 * @component @name LooksTwo
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVYxOUMzIDIwLjEgMy45IDIxIDUgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjVDMjEgMy45IDIwLjEgMyAxOSAzWk0xNSAxMUMxNSAxMi4xMSAxNC4xIDEzIDEzIDEzSDExVjE1SDE1VjE3SDlWMTNDOSAxMS44OSA5LjkgMTEgMTEgMTFIMTNWOUg5VjdIMTNDMTQuMSA3IDE1IDcuODkgMTUgOVYxMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LooksTwo = createIcon('LooksTwo', [
  [
    'path',
    {
      d: 'M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM15 11C15 12.11 14.1 13 13 13H11V15H15V17H9V13C9 11.89 9.9 11 11 11H13V9H9V7H13C14.1 7 15 7.89 15 9V11Z',
      key: '14cf3l',
    },
  ],
]);

export default LooksTwo;
